import { Button, Carousel, ConfigProvider } from 'antd'
import React, { useState } from 'react'

import slideone from '../../../../../public/sliders/slider (1).jpg'
import slidetow from '../../../../../public/sliders/slider (2).jpg'
import slidethree from '../../../../../public/sliders/slider (3).jpg'
import { useTranslation } from 'react-i18next'
import { Link } from '@inertiajs/react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

interface Slides {
    id: number;
    lang_id: number;
    title: string;
    subtitle: string;
    image: string;
}

interface Props {
    slides: Slides[]
}
export default function Sliders({ slides }: Props) {


    const { t, i18n } = useTranslation();

    const [AcitveIndex, setActiveIndex] = useState(0);

    const HandelActiveIndex = (current: number, next: number) => {
        setActiveIndex(next)
    }


    const CustomArrow = ({ direction, onClick }: any) => {
        const ArrowIcon = direction === 'prev' ? LeftOutlined : RightOutlined;
        return (
            <div

                style={{
                    color: 'black',
                    fontSize: '24px',
                    cursor: 'pointer',
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 1,
                    [direction === 'prev' ? 'left' : 'right']: '10px',
                }}

                onClick={onClick}
            >
                <ArrowIcon className='text-white hover:!text-custom-dark-blue' />
            </div>
        );
    };



    return (
        <div className='m-5  flex justify-center items-center flex-col '>
            <div className='w-full'>
                {slides?.length > 0 ?
                    <Carousel arrows autoplay infinite
                        beforeChange={HandelActiveIndex}
                        prevArrow={<CustomArrow direction="prev" />}
                        nextArrow={<CustomArrow direction="next" />}
                    >

                        {slides.map((item, index) =>
                            <div key={item.id}>
                                <div
                                    style={{

                                        height: '700px',
                                        backgroundImage: `url('${item.image}')`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                    className='relative'>
                                    <div className='flex flex-col items-center justify-center h-full overflow-hidden'>

                                        <div className='absolute w-full h-full bg-black top-0 right-0 opacity-50'></div>

                                        <p className={` text-sm lg:text-xl font-sans text-white drop-shadow-3xl  ${AcitveIndex === index ? 'animate-fadeup' : ''} `}>{item.title}</p>

                                        <p className={`w-1/2 pt-8 text-center text-sm lg:text-base font-sans font-bold text-white drop-shadow-3xl  ${AcitveIndex === index ? 'animate-fadeup' : ''}`}
                                            style={{
                                                animationDuration: "1s",
                                                animationDelay: "0.75s"
                                            }}
                                        >{item.subtitle}</p>

                                        {
                                            AcitveIndex === 0 ?

                                                <div className='flex justify-between items-center gap-4 mt-12 xs:flex-col'>
                                                    <Link href={route('client.appointment.index', { locale: i18n.language })}
                                                        className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                        style={{
                                                            animationDuration: "1s",
                                                            animationDelay: "1.5s"
                                                        }}
                                                    >
                                                        <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.getadvice')}</Button>
                                                    </Link>


                                                    <Link href={route('client.appointment.index', { locale: i18n.language })}
                                                        className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                        style={{
                                                            animationDuration: "1s",
                                                            animationDelay: "1s"
                                                        }}
                                                    >
                                                        <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.bookingnow')}</Button>
                                                    </Link>


                                                </div>
                                                : AcitveIndex === 1 ?

                                                    <div className='flex justify-between items-center gap-4 mt-12 xs:flex-col'>
                                                        <Link href={route('client.department.index', { locale: i18n.language })}
                                                            className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                            style={{
                                                                animationDuration: "1s",
                                                                animationDelay: "1.5s"
                                                            }}
                                                        >
                                                            <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.showservice')}</Button>
                                                        </Link>
                                                        <Link href={route('client.appointment.index', { locale: i18n.language })}
                                                            className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                            style={{
                                                                animationDuration: "1s",
                                                                animationDelay: "1s"
                                                            }}
                                                        >
                                                            <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.getadvice')}</Button>
                                                        </Link>
                                                    </div>

                                                    : AcitveIndex === 2 ?
                                                        <div className='flex justify-between items-center gap-4 mt-12 xs:flex-col'>
                                                            <Link href={route('client.contactus.index', { locale: i18n.language })}
                                                                className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                                style={{
                                                                    animationDuration: "1s",
                                                                    animationDelay: "1.5s"
                                                                }}
                                                            >
                                                                <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.contactuse')}</Button>

                                                            </Link>
                                                            <Link href={route('client.appointment.index', { locale: i18n.language })}
                                                                className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                                style={{
                                                                    animationDuration: "1s",
                                                                    animationDelay: "1s"
                                                                }}
                                                            >
                                                                <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.bookvisit')}</Button>
                                                            </Link>
                                                        </div>

                                                        : AcitveIndex === 3 &&
                                                        <div className='flex justify-between items-center gap-4 mt-12 xs:flex-col'>
                                                            <Link href={route('client.department.index', { locale: i18n.language })}
                                                                className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                                style={{
                                                                    animationDuration: "1s",
                                                                    animationDelay: "1.5s"
                                                                }}
                                                            >
                                                                <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.ourservice')}</Button>
                                                            </Link>
                                                            <Link href={route('client.appointment.index', { locale: i18n.language })}
                                                                className={`${AcitveIndex === index ? 'animate-fadeup' : ''} !font-sans`}
                                                                style={{
                                                                    animationDuration: "1s",
                                                                    animationDelay: "1s"
                                                                }}
                                                            >
                                                                <Button className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'>{t('sliders.slides_btn.callemergency')}</Button>
                                                            </Link>
                                                        </div>

                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                    </Carousel>
                    :

                    <Carousel
                    arrows
                    autoplay
                    infinite
                        beforeChange={HandelActiveIndex}
                        prevArrow={<CustomArrow direction="prev" />}
                        nextArrow={<CustomArrow direction="next" />}
                    >

                        <div >
                            <div style={{
                                margin: 0,
                                height: '500px',
                                color: '#fff',
                                lineHeight: '160px',
                                textAlign: 'center',
                                backgroundImage: `url('${slideone}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>

                                <div className='flex flex-col items-center justify-center  h-full'>

                                    <p className={` text-sm lg:text-xl font-bold text-white  drop-shadow-3xl  ${AcitveIndex === 0 ? 'animate-fadeup' : ''} `}>{t('sliders.slide_text.slide_one.title')}</p>

                                    <p className={`w-1/2 pt-8 text-center text-sm lg:text-base font-bold text-white leading-5 drop-shadow-3xl  xs:text-center ${AcitveIndex === 0 ? 'animate-fadeup' : ''}`}
                                        style={{
                                            animationDuration: "1s",
                                            animationDelay: "0.75s"
                                        }}
                                    >{t('sliders.slide_text.slide_one.subtitle')}</p>

                                    <Link href={route('client.appointment.index', { locale: i18n.language })}>
                                        <Button
                                        className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'
                                            style={{
                                                animationDuration: "1s",
                                                animationDelay: "1.5s"
                                            }}
                                        >{t('sliders.slides_btn.bookingnow')}</Button>
                                    </Link>

                                </div>

                            </div>
                        </div>

                        <div >
                            <div style={{

                                height: '500px',

                                backgroundImage: `url('${slidetow}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>

                                <div className='flex flex-col items-center justify-center  h-full'>
                                    <p className={` text-sm lg:text-xl font-bold text-white  drop-shadow-3xl  ${AcitveIndex === 1 ? 'animate-fadeup' : ''} `}>{t('sliders.slide_text.slide_tow.title')}</p>

                                    <p className={`w-1/2 py-8 text-center text-sm lg:text-base font-bold text-white  drop-shadow-3xl  xs:text-center ${AcitveIndex === 1 ? 'animate-fadeup' : ''}`}
                                        style={{
                                            animationDuration: "1s",
                                            animationDelay: "0.75s"
                                        }}
                                    >{t('sliders.slide_text.slide_tow.subtitle')}</p>
                                    <div className='flex justify-between items-center gap-4'>
                                        <Link href={route('client.appointment.index', { locale: i18n.language })}
                                            className='animate-fadeup'
                                            style={{
                                                animationDuration: "1s",
                                                animationDelay: "2s"
                                            }}
                                        >
                                            <Button
                                            className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'
                                            >{t('sliders.slides_btn.showservice')}</Button>
                                        </Link>
                                        <Link href={route('client.appointment.index', { locale: i18n.language })}
                                            className='animate-fadeup'
                                            style={{
                                                animationDuration: "1s",
                                                animationDelay: "1.5s"
                                            }}
                                        >
                                            <Button
                                            className='rounded-full lg:p-5 p-5 lg:text-base text-sm font-bold hover:!bg-[#38b6ffc7] hover:!border-white hover:!text-white !font-sans !bg-custom-dark-blue !border-white !text-white hover:border-4'
                                            >{t('sliders.slides_btn.getadvice')}</Button>
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div >
                            <div style={{

                                height: '500px',

                                backgroundImage: `url('${slidethree}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>
                                <div className='flex flex-col items-center justify-center  h-full'>
                                    <p className={` text-sm lg:text-xl font-bold text-white  drop-shadow-3xl  ${AcitveIndex === 2 ? 'animate-fadeup' : ''} `}>{t('sliders.slide_text.slide_three.title')}</p>

                                    <p className={`w-1/2 pt-8 text-center text-sm lg:text-base font-bold text-white  drop-shadow-3xl  xs:text-center ${AcitveIndex === 2 ? 'animate-fadeup' : ''}`}
                                        style={{
                                            animationDuration: "1s",
                                            animationDelay: "0.75s"
                                        }}
                                    >{t('sliders.slide_text.slide_three.subtitle')}</p>

                                </div>
                            </div>
                        </div>

                    </Carousel>
                }
            </div>

        </div>
    )
}
